import classnames from 'classnames';
import React, { useContext, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import TRANSLATIONS from '../../../translations/translations@default.json';
import { Context } from './store/store';

const BrandLogoImage = ({ Name, isReady }) => {
	const [, dispatch] = useContext(Context);

	const [loaded, setLoaded] = useState(false);
	const [error, setError] = useState(false);

	if (!Name) {
		return null;
	}

	const updateLoadedState = () =>
		dispatch({ type: 'SET_LOADED', payload: Name });

	const src = `//assets.ao.com/brand-logos/${
		TRANSLATIONS.general.currencyLocale
	}/${Name.toLowerCase()
		.replace(/\s/g, '')
		.replace('&', '-')
		.replace(/'+/g, '')
		.replace('+', '-')}.png`;

	return (
		<React.Fragment>
			{isReady && error && (
				<div className="flex items-center justify-center h-10 w-24 text-title">
					{Name}
				</div>
			)}
			{(!loaded || !isReady) && !error && <Skeleton width={100} height={40} />}
			{!error && (
				<img
					className={classnames({
						'opacity-0 w-0 h-0': !loaded || !isReady,
						'opacity-100': loaded && isReady,
					})}
					style={{ maxHeight: '32px' }}
					src={src}
					alt={Name}
					onLoad={() => {
						setLoaded(true);
						updateLoadedState();
					}}
					onError={() => {
						setError(true);
						updateLoadedState();
					}}
				/>
			)}
		</React.Fragment>
	);
};

export default BrandLogoImage;
